import type { I18N } from '@vista-digital/i18n'
import type { Film } from '@vista-digital/ocapi-types/v1'
import { gtm } from '../../gtm.service'
import type { EcommerceItem, EcommerceItemListProps } from '../../models-gtm'
import { Ecommerce, EcommerceDataLayer } from '../../models-gtm'
import { mapFilmData } from '../../utils/mapFilmData'

export enum FilmListIdType {
    films_page_top_films,
    home_page_top_films,
    films_page_all_films,
    events_page_all_films,
    custom_films,
}

export const filmListIdTypeValues: { [key in FilmListIdType]: EcommerceItemListProps } = {
    [FilmListIdType.films_page_top_films]: {
        item_list_id: 'films-page-top-films',
        item_list_name: 'Top Films',
    },
    [FilmListIdType.home_page_top_films]: {
        item_list_id: 'home-page-top-films',
        item_list_name: 'Top Films',
    },
    [FilmListIdType.films_page_all_films]: {
        item_list_id: 'films-page-all-films',
        item_list_name: 'All Films',
    },
    [FilmListIdType.events_page_all_films]: {
        item_list_id: 'events-page-all-films',
        item_list_name: 'All Events Films',
    },
    [FilmListIdType.custom_films]: {
        item_list_id: 'custom-films',
        item_list_name: 'Custom Films',
    },
}

export class FilmsGtmEvents {
    public static viewItem(film: Film, userPath: string, i18n: I18N) {
        if (!film) return

        const item = this.getFilmBaseItemForLayer(film, i18n)
        item.user_path = userPath

        gtm.sendDataLayer(new EcommerceDataLayer('view_item', new Ecommerce([item])))
    }

    public static selectItem(film: Film, itemListId: FilmListIdType, index: number, i18n: I18N) {
        const item = this.getFilmListItemForLayer(film, itemListId, index, i18n)

        gtm.sendDataLayer(new EcommerceDataLayer('select_item', new Ecommerce([item])))
    }

    public static viewItemList(films: Film[], itemListId: FilmListIdType, i18n: I18N) {
        const items = films.map((film: Film, index: number) =>
            this.getFilmListItemForLayer(film, itemListId, index, i18n)
        )

        gtm.sendDataLayer(new EcommerceDataLayer('view_item_list', new Ecommerce(items)))
    }

    // Private methods

    private static getFilmBaseItemForLayer(film: Film, i18n: I18N): EcommerceItem {
        return mapFilmData(film, i18n)
    }

    private static getFilmListItemForLayer(
        film: Film,
        itemListId: FilmListIdType,
        index: number,
        i18n: I18N
    ): EcommerceItem {
        const item = this.getFilmBaseItemForLayer(film, i18n)

        item.item_list_id = filmListIdTypeValues[itemListId].item_list_id
        item.item_list_name = filmListIdTypeValues[itemListId].item_list_name
        item.index = index

        return item
    }
}
